import { useState } from "react";
import { ApiError } from "../../api/client";
import { reactivateAppointment } from "../../api/appointments";
import "../lesson-reports/LessonReportModal.css";
import "./CancelAppointmentModal.css";

type Props = {
  appointmentId: string;
  studentName?: string;
  startsAt?: string;
  endsAt?: string;
  onClose: () => void;
  onReactivated?: () => void;
};

export function ReactivateAppointmentModal({
  appointmentId,
  studentName,
  startsAt,
  endsAt,
  onClose,
  onReactivated,
}: Props) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const timeLabel =
    startsAt && endsAt
      ? `${new Date(startsAt).toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" })} – ${new Date(endsAt).toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" })}`
      : null;

  const handleConfirm = async () => {
    setError(null);
    setBusy(true);
    try {
      await reactivateAppointment(appointmentId);
      onReactivated?.();
      onClose();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Randevu yeniden aktifleştirilemedi.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="report-modal-backdrop" role="dialog" aria-modal="true">
      <div className="report-modal cancel-appt-modal">
        <div className="report-modal__header">
          <div>
            <h3>Dersi yeniden aktifleştir</h3>
            <div className="report-modal__sub">
              {studentName && <span>{studentName}</span>}
              {timeLabel && <span> · {timeLabel}</span>}
            </div>
          </div>
          <button type="button" className="report-modal__close" onClick={onClose} aria-label="Kapat">
            ×
          </button>
        </div>

        <div className="report-modal__body cancel-appt-modal__body">
          <p className="cancel-appt-modal__hint">
            Ders tekrar planlı duruma alınır. İptal sebebi ve iptal kaydı kaldırılır. Aynı saatte başka
            randevu veya engel varsa işlem yapılamaz.
          </p>
          {error && <div className="cancel-appt-modal__error">{error}</div>}
        </div>

        <div className="cancel-appt-modal__footer">
          <button type="button" className="kp-btn kp-btn--ghost" onClick={onClose} disabled={busy}>
            Vazgeç
          </button>
          <button type="button" className="kp-btn kp-btn--primary" onClick={handleConfirm} disabled={busy}>
            {busy ? "Aktifleştiriliyor..." : "Dersi Yeniden Aktifleştir"}
          </button>
        </div>
      </div>
    </div>
  );
}
